import { createBrowserHistory } from 'history';

const useHistory = () => {
  const history = createBrowserHistory();
  return history;
};

export default useHistory;
